import { SnackbarProvider } from 'notistack'
import DashboardLayout from '../components/DashboardLayout'
import PodiumsDataGrid from './components/PodiumsDataGrid'

export default function PodiumsOverviewPage() {
    return (
        <DashboardLayout>
            <PodiumsDataGrid />

            <SnackbarProvider
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            />
        </DashboardLayout>
    )
}
